/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandCampaignmonitor = createReactComponent("outline", "brand-campaignmonitor", "IconBrandCampaignmonitor", [["path", { "d": "M3 18l9 -6.462l-9 -5.538v12h18v-12l-9 5.538", "key": "svg-0" }]]);

export { IconBrandCampaignmonitor as default };
//# sourceMappingURL=IconBrandCampaignmonitor.mjs.map
